(() => {
  if (typeof window === "undefined" || typeof PerformanceObserver === "undefined") {
    return;
  }

  const dataLayer = Array.isArray(window.dataLayer) ? window.dataLayer : null;
  const navEntry = performance.getEntriesByType("navigation")[0];
  const pageType = window.Shopify?.analytics?.meta?.page?.pageType || navEntry?.type || "unknown";

  const reports = {
    cls: {
      value: 0,
      entries: []
    },
    lcp: {
      value: null,
      entry: null
    },
    fid: {
      value: null,
      entry: null
    }
  };

  function emit(eventName, payload) {
    if (dataLayer) {
      dataLayer.push({
        event: `performance:${eventName}`,
        pageType,
        ...payload
      });
    }
    if (window.Shopify?.designMode) {
      console.info(`[perf:${eventName}]`, payload);
    }
  }

  // CLS observer
  try {
    const layoutShiftObserver = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (entry.hadRecentInput) continue;
        reports.cls.value += entry.value;
        reports.cls.entries.push({
          value: entry.value,
          sources: entry.sources?.map((source) => {
            const node = source.node;
            return node && node instanceof HTMLElement
              ? {
                  tag: node.tagName,
                  id: node.id,
                  class: node.className,
                  current: {
                    x: Math.round(source.currentRect?.x || 0),
                    y: Math.round(source.currentRect?.y || 0),
                    width: Math.round(source.currentRect?.width || 0),
                    height: Math.round(source.currentRect?.height || 0)
                  },
                  previous: source.previousRect
                    ? {
                        x: Math.round(source.previousRect.x || 0),
                        y: Math.round(source.previousRect.y || 0),
                        width: Math.round(source.previousRect.width || 0),
                        height: Math.round(source.previousRect.height || 0)
                      }
                    : null
                }
              : null;
          }).filter(Boolean)
        });
      }
    });
    layoutShiftObserver.observe({ type: "layout-shift", buffered: true });
  } catch (error) {
    console.warn("[perf-monitor] CLS observer failed", error);
  }

  // LCP observer
  try {
    const lcpObserver = new PerformanceObserver((list) => {
      const entries = list.getEntries();
      const lastEntry = entries[entries.length - 1];
      if (!lastEntry) return;
      reports.lcp.value = lastEntry.renderTime || lastEntry.loadTime;
      reports.lcp.entry = {
        url: lastEntry.url,
        element: lastEntry.element?.tagName || null,
        id: lastEntry.id || null,
        size: lastEntry.size
      };
    });
    lcpObserver.observe({ type: "largest-contentful-paint", buffered: true });
  } catch (error) {
    console.warn("[perf-monitor] LCP observer failed", error);
  }

  // FID observer
  try {
    const fidObserver = new PerformanceObserver((list) => {
      const entry = list.getEntries()[0];
      if (!entry) return;
      reports.fid.value = entry.processingStart - entry.startTime;
      reports.fid.entry = {
        name: entry.name,
        startTime: entry.startTime,
        duration: entry.duration
      };
      emit("fid", {
        value: reports.fid.value,
        detail: reports.fid.entry
      });
    });
    fidObserver.observe({ type: "first-input", buffered: true });
  } catch (error) {
    console.warn("[perf-monitor] FID observer failed", error);
  }

  function flushReports(trigger) {
    if (reports.cls.value > 0) {
      emit("cls", {
        trigger,
        value: Number(reports.cls.value.toFixed(4)),
        samples: reports.cls.entries.slice(-3)
      });
    }
    if (reports.lcp.value !== null) {
      emit("lcp", {
        trigger,
        value: Math.round(reports.lcp.value),
        detail: reports.lcp.entry
      });
    }
  }

  window.addEventListener(
    "visibilitychange",
    () => {
      if (document.visibilityState === "hidden") {
        flushReports("visibilitychange");
      }
    },
    { once: true }
  );

  window.addEventListener(
    "pagehide",
    () => {
      flushReports("pagehide");
    },
    { once: true }
  );
})();
